import './App.css';
import React, { useEffect, useState } from 'react';
import { TezosToolkit } from '@taquito/taquito';
import { BeaconWallet } from '@taquito/beacon-wallet';
import { bytesToString } from "@taquito/utils";

const App = () => {
	const [bakerAddress, setBakerAddress] = useState('tz1eo3APJNdYst3mu7axpyZsJBPEqwxm8Sv1');
	const [payoutAddress, setPayoutAddress] = useState('tz1Lz19xKSsczwGGZw7VkVkrN1x3xYZyGfts');
	const [isDelegating, setIsDelegating] = useState(null);
	const [userAddress, setUserAddress] = useState('');
	const [tezosDomainOrAddress, setTezosDomainOrAddress] = useState('');
	const [tzktUserAddress, setTzktUserAddress] = useState('#');
	const [tzktBakerAddress, setTzktBakerAddress] = useState('#');
	const [tzktBakerActivity, setTzktBakerActivity] = useState('https://tzkt.io/' + bakerAddress + '/schedule');
	const [isConnected, setIsConnected] = useState(false);
	const [isStaking, setIsStaking] = useState(false);
	const [alreadyStaking, setAlreadyStaking] = useState(Number(0));
	const [userBalance, setUserBalance] = useState(Number(0));
	const [maxStake, setMaxStake] = useState(Number(0));
	const [stake, setStake] = useState(Number(0));
	
	let Tezos = new TezosToolkit('https://tezos.storry.tv');
	const options = {
	  name: 'StorryTV - Tezos (tezos.storry.tv)',
	  iconUrl: 'https://storry.tv/favicon.ico',
	  network: { type: 'mainnet' },
	  enableMetrics: true,
	};
	
	let wallet;
	try {
		wallet = new BeaconWallet(options);
		Tezos.setWalletProvider(wallet);
		Tezos.setProvider({signer: wallet});
	} catch (err) {
		console.error(err);
	}
	
	const getUserAddress = async () => {
		try {
			let address = await wallet.getPKH();
			await getTezosDomainOrAddress(address);
			setUserAddress(address);
			setIsConnected(true);
			let balance = await Tezos.tz.getBalance(address);
			balance = balance ? balance.toNumber() : 0;
			
			let maxStake = getMaxStake(balance);
			setMaxStake(maxStake);
			setUserBalance(await Tezos.tz.getBalance(await wallet.getPKH()));
			return userAddress;
		} catch (err) {
			if (localStorage.getItem('beacon:accounts') && localStorage.getItem('beacon:accounts') !== 'undefined' && localStorage.getItem('beacon:accounts') !== '' && JSON.parse(localStorage.getItem('beacon:accounts'))[0]?.address) {
				await getTezosDomainOrAddress((JSON.parse(localStorage.getItem('beacon:accounts'))[0]?.address || ''));
				setUserAddress(JSON.parse(localStorage.getItem('beacon:accounts'))[0]?.address || '');
				setIsConnected(true);
				setUserBalance(await Tezos.tz.getBalance(JSON.parse(localStorage.getItem('beacon:accounts'))[0]?.address || ''));
				return JSON.parse(localStorage.getItem('beacon:accounts'))[0]?.address || '';
			} else {
				setUserAddress('');
				setIsConnected(false);
				return '';
			}
		}
	}
	
	const UserAddress = async () => {
		try {
			if (userAddress !== '') {
				return userAddress;
			} else {
				return await wallet.getPKH();
			}
		} catch (err) {
			if (localStorage.getItem('beacon:accounts') !== 'undefined' && localStorage.getItem('beacon:accounts') !== null) {
				return JSON.parse(localStorage.getItem('beacon:accounts'))[0]?.address || '';
			} else {
				return '';
			}
		}
	}
	
	const getTezosDomainOrAddress = async (_address = '') => {
		let address = (_address === '') ? await UserAddress() : _address;
		if (address && address !== '') {
			//const Tezos_ = new TezosToolkit("https://mainnet.tezos.ecadinfra.com");
			const domainContractAddress = 'KT1GBZmSxmnKJXGMdMLbugPfLyUPmuLSMwKS';
			const TezosDomainContract = await Tezos.wallet.at(domainContractAddress);
			const storage: any = await TezosDomainContract.storage();
			const domain = await storage.store.reverse_records.get(address);
			if (domain) {
				setTezosDomainOrAddress(bytesToString(domain.name.Some));
				//return bytesToString(domain.name);
			} else {
				setTezosDomainOrAddress(address);
				//return address;
			}
		}
	}
	
	const checkifstaking = async () => {
		try {		
			const balance = await Tezos.tz.getBalance(await UserAddress());
			//window.Tezos = Tezos;
			//window.wallet = wallet;
		    //const staked = balance ? balance.toNumber() : 0;
		    fetch('https://api.tzkt.io/v1/accounts/' + await UserAddress() + '/balance', {
				'method': 'GET',
				'accept': 'application/json'
			})
			.then((response) => response.text())
			.then((data) => {
				if (Number(data) >= 1) {
					setAlreadyStaking((Number(data) - balance) / 1000000);
				}
			});
		    setIsStaking(balance ? true : false);
		    return isStaking;
			
			//await getUserAddress();
			
			/*fetch('https://api.tzkt.io/v1/staking/updates?staker=' + userAddress + '&sort.desc=id&limit=1', {
				'method': 'GET',
				'accept': 'application/json'
			})
			.then((response) => response.json())
			.then((data) => {
				if (data[0] && data[0]?.baker?.address === bakerAddress && data[0]?.amount >= 1) {
					setIsStaking(true);
				} else {
					setIsStaking(false);
				}
				if (data[0] && data[0]?.amount >= 1) {
					stakingAmount = Number(data[0]?.amount);
				}
				setAlreadyStaking(stakingAmount);
				return isStaking;
			});*/
		} catch (err) {
			console.error(err);
		}
	};
	
	const connectWallet = async () => {
		try {
			await wallet.requestPermissions(options);
			let address = await wallet.getPKH();
			await getTezosDomainOrAddress(address);
			setUserAddress(address);
			setIsConnected(true);
			
			let balance = await Tezos.tz.getBalance(address);
			balance = balance ? balance.toNumber() : 0;
			
			let maxStake = getMaxStake(balance);
			setMaxStake(maxStake);
			setUserBalance(balance);
			
			await checkifstaking();
			
			//getMaxStake();
			//window.location.reload();
		} catch (err) {
			console.error(err);
		}
	};
	
	const logoutWallet = () => {
		localStorage.clear();
		window.location.reload();
	};
	
	const delegateTo = async () => {
		try {
			if (userAddress && userAddress !== '') {
				await connectWallet();
				let delegate = await Tezos.tz.getDelegate(userAddress);
				if (delegate !== bakerAddress) {
					setTzktUserAddress('#');
					setTzktBakerAddress('#');
					setIsDelegating(null);
					const op = await Tezos.wallet.setDelegate({ delegate: bakerAddress }).send();
					console.log(`Delegate Operation: '${await op.opHash}'`);
					await op.confirmation();
					setTzktUserAddress('https://tzkt.io/' + userAddress + '/rewards');
					setTzktBakerAddress('https://tzkt.io/' + bakerAddress + '/rewards');
				} else {
					setTzktUserAddress('https://tzkt.io/' + userAddress + '/rewards');
					setTzktBakerAddress('https://tzkt.io/' + bakerAddress + '/rewards');
					setIsDelegating(true);
				}
			} else {
				await connectWallet();
			}
		} catch (err) {
			console.error(err);
		}
	};
	
	const stakeTo = async () => {
		try {
			const op = await Tezos.wallet.stake({
				amount: (document.getElementById('stakeAmount').value * 1000000) || (stake > 0 ? stake : ((userBalance < 100000) ? 0 : (userBalance - 100000))),
				mutez: true
			}).send({ source: userAddress });
			console.log(`Stake Operation: '${await op.opHash}'`);
			await op.confirmation();
		} catch (err) {
			console.error(err);
		}
	};
	
	const stakeMax = async () => {
		try {
			const op = await Tezos.wallet.stake({
				amount: (stake > 0 ? stake : ((userBalance < 100000) ? 0 : (userBalance - 100000))),
				mutez: true
			}).send({ source: userAddress });
			console.log(`Stake Operation: '${await op.opHash}'`);
			await op.confirmation();
		} catch (err) {
			console.error(err);
		}
	};
	
	const changeStake = (event) => {
		if (event.target.value !== '') {
			setStake(event.target.value);
		} else {
			setStake((stake > 0 ? stake : ((userBalance < 100000) ? 0 : (userBalance - 100000))));
		}
	};
	
	const getMaxStake = (balance) => {
		//setMaxStake((userBalance < 1000000) ? 0 : ((userBalance - 1000000) / 1000000));
		//setMaxStake((stake > 0 ? stake : ((userBalance < 1000000) ? 0 : ((userBalance - 1000000) / 1000000))));
		return (balance < 100000) ? 0 : ((balance - 100000) / 1000000);		
	};

	useEffect(() => {
		try {
			checkifstaking();
		} catch (err) {
			console.error(err);
		}
		const checkDelegation = async () => {
			try {
				let delegate = await Tezos.tz.getDelegate(userAddress);
				if (delegate === bakerAddress) {
					setTzktUserAddress('https://tzkt.io/' + userAddress + '/rewards');
					setTzktBakerAddress('https://tzkt.io/' + bakerAddress + '/rewards');
					setIsDelegating(true);
				} else {
					setTzktUserAddress('https://tzkt.io/' + userAddress + '/rewards');
					setTzktBakerAddress('https://tzkt.io/' + bakerAddress + '/rewards');
					setIsDelegating(false);
				}
			} catch (error) {
				console.error('Error fetching delegation:', error);
				setTzktUserAddress('#');
				setTzktBakerAddress('#');
				setIsDelegating(false);
			}
		};
		if (userAddress && bakerAddress) {
			//getTezosDomainOrAddress(userAddress);
			checkDelegation();
		} else {
			//getTezosDomainOrAddress();
			getUserAddress();
		}
	}, [userAddress, bakerAddress, Tezos]);
	
	/*useEffect(() => {
		const maxStake = getMaxStake();
		setMaxStake(maxStake);
	}, [userBalance]);*/

  return (
    <div className="App">
      <a target="_blank" href="https://storry.tv/">
		<img
		  src="https://ipfs.storry.tv/ipfs/QmZkfAaSk1msKU7ea3ZfLQHyZyGnAuQ2VhpdLouSvSPxUM/logo%202022%20transparent.png?filename=logo%202022%20transparent.png"
		  alt="StorryTV Uncensored Videos"
		  title="StorryTV Uncensored Videos"
		  crossOrigin="anonymous"
		  referrerPolicy="no-referrer"
		  async=""
		/>
	  </a>
	  <h1>StorryTV public baker for Tezos</h1>
	  <h3>
		Baker address: <em>{bakerAddress}</em>
	  </h3>
	  <h3>
		Payout address: <em>{payoutAddress}</em>
	  </h3>
	  {isDelegating === null ? (
        <p></p>
      ) : isStaking && alreadyStaking > 0.000001 ? (
      	<p style={{ color: "#62ff00", fontSize: 24 }}>✅ <a href={tzktUserAddress} target="_blank">{tezosDomainOrAddress}</a> is already delegating and staking {alreadyStaking} ꜩ with <a href={tzktBakerAddress} target="_blank">StorryTV Baker</a>.</p>
      ) : isDelegating ? (
      	<>
        <p style={{ color: "#62ff00", fontSize: 24 }}>✅ <a href={tzktUserAddress} target="_blank">{tezosDomainOrAddress}</a> is delegating with <a href={tzktBakerAddress} target="_blank">StorryTV Baker</a>.</p>
        <p style={{ color: "#ff0000", fontSize: 24 }}>❌ ,but not yet staking.</p>
        </>
      ) : (
      	<p style={{ color: "#ff0000", fontSize: 24 }}>❌ <a href={tzktUserAddress} target="_blank">{userAddress}</a> is not delegating with <a href={tzktBakerAddress} target="_blank">StorryTV Baker</a>.</p>
      )}
	  {isConnected === false ? (
        <button onClick={connectWallet}>Connect wallet and delegate</button>
      ) : isDelegating !== true ? (
        <button onClick={delegateTo}>Click to delegate with us</button>
      ) : isStaking && ((stake > 0) || (userBalance >= 100000)) ? (
      	<>
      	<input style={{ color: "#313131", fontSize: 24, fontWeight: 700, marginRight: 20 }} type="number" id="stakeAmount" name="stakeAmount" min="0.000001" max={maxStake} step="0.000001" />
      	<button onClick={stakeTo}>Stake</button>
      	<br />
      	<br />
      	<button onClick={stakeMax}>Stake Max Amount ({maxStake} ꜩ)</button>
      	</>
      ) : (
      	<>
      	<p>You're already staking with the maximum ꜩ available</p>
      	</>
      )}
      <br />
      <br />
      <br />
      <br />
      {isConnected ? (
      <button onClick={logoutWallet}>Logout</button>
      ) : (
        <></>
      )}
      <br />
      <br />
	  <h3>
		Stake with us! Connect your wallet via{" "}
		<a href="https://www.templewallet.com/" target="_blank">
		  Temple
		</a>
		,{" "}
		<a href="https://wallet.kukai.app/" target="_blank">
		  Kukai
		</a>
		,{" "}
		<a href="https://umamiwallet.com/" target="_blank">
		  Umami
		</a>
		,{" "}
		<a href="https://trustwallet.com/" target="_blank">
		  Trust
		</a>{" "}
		or{" "}
		<a href="https://guarda.com/" target="_blank">
		  Guarda
		</a>{" "}
		and search for StorryTV Baker or put in{" "}
		<em>{bakerAddress}</em> manually to delegate and go to{" "}
		<a href="https://stake.tezos.com/" target="_blank">
		  https://stake.tezos.com
		</a>{" "}
		to start staking with us!
	  </h3>
	  <small>
		Learn how to delegate using{" "}
		<a href="https://www.youtube.com/watch?v=kbRtHBvgvFw" target="_blank">
		  Ledger Live
		</a>
		.
	  </small>
	  <h3>
		Staking fees: <em>0%</em>
	  </h3>
	  <h3>
		Delegating fees: <em>20%</em>
	  </h3>
	  <h3>
		Minimum staking amount: <em>0 ꜩ</em>
	  </h3>
	  <h3>
		Minimum delegation amount: <em>100 ꜩ</em>
	  </h3>
	  <h3>
		Payout: <em>every cycle</em>
	  </h3>
	  <br />
	  <h2>First verify that our baker is NOT over-delegated before choosing us!</h2>
	  <p>
		Check our activity on{" "}
		<a
		  href={tzktBakerActivity}
		  target="_blank"
		>
		  tzkt.io
		</a>
	  </p>
	  <p>
		Follow us on{" "}
		<a href="https://x.com/StorryTV" target="_blank">
		  X (Twitter) @StorryTV
		</a>
		.
	  </p>
	  <p>
		Contact:{" "}
		<a href="https://storry.tv/contact" target="_blank">
		  https://storry.tv/contact
		</a>{" "}
		or send an email to{" "}
		<a href="mailto:support@email.storry.tv">support@email.storry.tv</a>
	  </p>
    </div>
  );
}

export default App;
